import {
  PdfGen,
  PdfUnit,
  PdfSize,
  PdfRect,
  PdfBrush,
  PdfColor,
  PdfFont,
  ETextAlign,
} from '../../pdf/pdf';
import { ILayoutLabelGen } from '../layoutLabel';
import { OptsLabel } from '../optsLabel';
import { GUtil } from '../../pdf/gutil';
import { IItemCount } from '@educraft/base';
import { getHolidays } from '../../core/calendar';
import '../../pdf/draw/primitives';
import '../../pdf/draw/string';
import '../../pdf/draw/image';
import '../../pdf/draw/label';

export abstract class KalendarMesic__Base implements ILayoutLabelGen, IItemCount {
  countDefault(): number {
    return 12;
  }
  countMin(): number {
    return 1;
  }
  countMax(): number {
    return 12;
  }

  protected abstract get yearOffset(): number;

  public async generate(pdf: PdfGen, opts: OptsLabel): Promise<void> {
    const year = new Date().getFullYear() + this.yearOffset;

    const {lang} = opts.data;
    const months = [
      lang.Kalendar_Month_leden ?? 'January',
      lang.Kalendar_Month_unor ?? 'February',
      lang.Kalendar_Month_brezen ?? 'March',
      lang.Kalendar_Month_duben ?? 'April',
      lang.Kalendar_Month_kveten ?? 'May',
      lang.Kalendar_Month_cerven ?? 'June',
      lang.Kalendar_Month_cervenec ?? 'July',
      lang.Kalendar_Month_srpen ?? 'August',
      lang.Kalendar_Month_zari ?? 'September',
      lang.Kalendar_Month_rijen ?? 'October',
      lang.Kalendar_Month_listopad ?? 'November',
      lang.Kalendar_Month_prosinec ?? 'December',
    ];

    const labelSize = { width: PdfUnit.FromMillimeters(95), height: PdfUnit.FromMillimeters(30) };
    const defaultLabelFont = new PdfFont(PdfFont.FONT_NAME, 72);

    const background = new PdfBrush(PdfColor.fromCmyk(0, 0, 0, 0, 0.6));

    const holidays = getHolidays(year, opts.data.langCode);

    const monthFont = new PdfFont(PdfFont.FONT_NAME, 128);
    const nameFont = new PdfFont(PdfFont.FONT_NAME, 88);
    const yearFont = new PdfFont(PdfFont.FONT_NAME, 36);
    const redBrush = new PdfBrush(PdfColor.fromRgb(255, 0, 0));

    for (let month = 1; month <= 12; month++) {
      const page = pdf.addPage();
      const item = opts.list[(month - 1) % opts.list.length];

      const month1Rect = new PdfRect(
        PdfUnit.FromMillimeters(10),
        PdfUnit.FromMillimeters(10),
        PdfUnit.FromMillimeters(45),
        PdfUnit.FromMillimeters(50)
      );
      const month2Rect = new PdfRect(
        month1Rect.x + month1Rect.width + PdfUnit.FromMillimeters(20),
        month1Rect.y,
        PdfSize.A4.width -
          (month1Rect.x + month1Rect.width + PdfUnit.FromMillimeters(20)) -
          PdfUnit.FromMillimeters(15),
        PdfUnit.FromMillimeters(50)
      );

      const adjustedNameFont = page.adjustFont(month2Rect.width, months, nameFont);

      const imageS = PdfUnit.FromMillimeters(140);
      const imageRect = new PdfRect(
        (PdfSize.A4.width - imageS) / 2,
        month1Rect.y + month1Rect.height + 10,
        imageS,
        imageS
      );

      page.drawLabel(item.left, { rect: imageRect });

      page.drawString(
        `${month}`,
        monthFont,
        PdfBrush.Black,
        null,
        month1Rect,
        ETextAlign.RightBaseline
      );

      page.drawString(
        months[month - 1],
        adjustedNameFont,
        PdfBrush.Black,
        null,
        month2Rect,
        ETextAlign.LeftBaseline
      );

      const yearRect = new PdfRect(
        month1Rect.x,
        month1Rect.y + month1Rect.height,
        month1Rect.width,
        PdfUnit.FromMillimeters(20)
      );
      page.drawString(`${year}`, yearFont, PdfBrush.Black, null, yearRect, ETextAlign.TopRight);

      const firstDayOfWeek = new Date(year, month - 1, 1).getDay();
      const daysInMonth = new Date(year, month, 0).getDate();
      const daySize = { width: PdfUnit.FromMillimeters(20), height: PdfUnit.FromMillimeters(12) };

      for (let d = 1; d <= daysInMonth; d++) {
        const dd = firstDayOfWeek + d + 5;
        const x = dd % 7;
        const y = Math.floor(dd / 7);

        const dayRect = new PdfRect(
          PdfUnit.FromMillimeters(60) + x * daySize.width - daySize.width,
          PdfSize.A4.height - PdfUnit.FromMillimeters(85) + y * daySize.height - daySize.height,
          daySize.width,
          daySize.height
        );

        const isHoliday = holidays.some((h) => h.getMonth() === month - 1 && h.getDate() === d);
        const brush = isHoliday ? redBrush : PdfBrush.Black;

        page.drawString(`${d}`, GUtil.baseFont, brush, null, dayRect, ETextAlign.BottomRight);
      }
    }
  }
}

export class KalendarMesic__TentoRok extends KalendarMesic__Base {
  protected get yearOffset(): number {
    return 0;
  }
}

export class KalendarMesic__DalsiRok extends KalendarMesic__Base {
  protected get yearOffset(): number {
    return 1;
  }
}
